var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 898,
    height: 458,
    viewBox: "0 0 898 458",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.926 138.532l415.02-133.49a100 100 0 0162.328.358l282.265 94.373c42.779 14.303 70.687 55.474 68.13 100.508l-6.26 110.256c-2.818 49.63-41.663 89.655-91.187 93.956l-604.614 52.51a100 100 0 01-90.62-42.343l-86.41-123.65c-31.636-45.27-20.584-107.614 24.686-139.25a100 100 0 0126.662-13.228z",
    fill: "#F8DF3E",
    opacity: 0.2
  })));
}

export default SvgBg;